import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import P from './P';
import SVG from './SVG';
import Colours from '../tokens/colours';
import FontSizes from '../tokens/fontSizes';
import FontWeights from '../tokens/fontWeights';
import MediaQueries from '../tokens/MediaQueries';
const sizeObject = {
    small: 20,
    medium: 22,
    large: 24,
};
const getStyles = createUseStyles({
    root: {
        position: 'relative',
        '&selected': {
            backgroundColor: 'red'
        }
    },
    accountInitial: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: FontSizes.Small,
        position: 'absolute',
        color: Colours.white,
        fontWeight: FontWeights.Bold,
        zIndex: 0,
        top: 0,
        [MediaQueries.desktop]: {
            fontSize: FontSizes.Big
        }
    },
});
const AccountIcon = (props) => {
    const { className, accountInitial, size } = props;
    const styles = getStyles();
    return (React.createElement("div", { className: classNames(styles.root, className) },
        React.createElement(SVG, { height: `${sizeObject[size]}px`, width: `${sizeObject[size]}px` },
            React.createElement("circle", { fill: 'currentColor', cx: `${sizeObject[size] / 2}`, cy: `${sizeObject[size] / 2}`, r: `${sizeObject[size] / 2}` })),
        React.createElement(P, { className: styles.accountInitial }, accountInitial)));
};
export default AccountIcon;
//# sourceMappingURL=AccountIcon.js.map